export function upperCaseFirsteLetter(string: string): string {
  return string.slice(0, 1).toLocaleUpperCase() + string.slice(1);
}
